import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PolicyProvision } from '@heda/core-util/model/policy-provision';

@Component({
  selector: 'hw-policy-provision-input',
  templateUrl: './policy-provision-input.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PolicyProvisionInputComponent), multi: true },
  ],
})
export class PolicyProvisionInputComponent implements ControlValueAccessor {
  @Input() public disabled: boolean;
  @Input() public actors = ['patient', 'representee', 'practitioner']; // supported also: patient-response
  @Input() public readonlyActors = [];
  @Output() public hwChange = new EventEmitter<PolicyProvision[]>();

  public val: { [actor: string]: string } = {};

  public onChange = (x: any) => x;

  public readonlyActor = (actor: string): boolean => {
    return this.readonlyActors.indexOf(actor) !== -1;
  };

  public writeValue(obj: PolicyProvision[]): void {
    this.val = {};
    if (obj) {
      obj.forEach((pp) => (this.val[pp.actor] = pp.policy));
    }
    this.actors.forEach((a) => (this.val[a] = this.val[a] || 'allow'));
  }

  private fireOnChange(): void {
    const result = Object.keys(this.val)
      .filter((k) => this.actors.indexOf(k) !== -1)
      .filter((k) => !!this.val[k])
      .map((k) => ({
        actor: k,
        policy: this.val[k],
      }));

    this.onChange(result);
    this.hwChange.emit(result);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {}

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
